const commaNumber = number => {
  if (number && !Number.isNaN(Number(number))) {
    return `$${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }

  return number;
};

export default commaNumber;
